import { useDataValue } from 'Simple/Data.js'

export function useOnClick(props) {
  let { recipient_id, postal_address_id } = useDataValue({
    viewPath: props.viewPath,
    context: 'picker',
  })

  return function click() {
    if (typeof props.onSave === 'function')
      props.onSave(recipient_id, postal_address_id)
    if (typeof props.closePopover === 'function') props.closePopover()
  }
}
